import type { Fallacy } from "./types";
import { createStory } from "./types";

export const appealToEmotion: Fallacy = {
    id: "appeal-to-emotion",
    name: "Appeal to Emotion",
    emoji: "😢",
    category: "Manipulasi Emosi & Sosial",
    description:
      "Menggunakan **emosi** (kasihan, takut, marah) untuk meyakinkan orang, bukan **argumen logis dan bukti**.",
    detail:
      "Appeal to Emotion terjadi ketika seseorang menggunakan **manipulasi emosi** — kasihan, takut, marah, bangga, atau bersalah — untuk **memenangkan argumen** tanpa bukti. Emosi bukan masalah; yang salah adalah ketika emosi digunakan sebagai **PENGGANTI argumen**, bukan pelengkapnya.\n\nJenis-jenisnya:\n• **Appeal to Pity**: \"Kasihan dong, mereka kan sudah berusaha.\"\n• **Appeal to Fear**: \"Kalau gak setuju, nanti kamu yang rugi.\"\n• **Appeal to Guilt**: \"Setelah semua yang saya korbankan, kamu masih menolak?\"\n\nCara mengenali: Pisahkan emosi dari argumen. Kalau emosi dihilangkan, apakah masih ada argumen yang tersisa?",
    tldr: "Main emosi buat menang debat? Data mana data? Appeal to Emotion tuh.",
    story: createStory("Appeal to Emotion", "😢", {
      hook: {
        title: "Argumen kamu solid, datanya lengkap...",
        body: "Tapi lawan kamu bales pake **emosi** — kasihan, takut, marah. Dan tiba-tiba kamu yang salah.",
      },
      convo: {
        claim: "Pak, saya udah begadang 3 malam sampe sakit. **Masa usaha segitu gak dihargai?** Kasihan dong!",
        response: "Usaha keras gak otomatis bikin proposal jadi valid. **Data pendukungnya tetap harus kuat.**",
      },
      reveal: {
        body: "Pake **manipulasi perasaan** — kasihan, takut, rasa bersalah — buat menang debat. Emosi jadi **pengganti argumen**, bukan pelengkap.",
      },
      insight: {
        title: "Tes gampangnya?",
        body: "**Hilangkan emosinya.** Kalau emosi dihapus dan gak ada argumen yang tersisa — itu bukan argumen, itu manipulasi.",
      },
      engagement: {
        title: "Paling ampuh bikin kamu luluh: kasihan, takut, atau rasa bersalah?",
        body: "Pilih satu yang paling sering kena! **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-authority", "bandwagon", "red-herring"],
  };
